import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage, { getDefaultData } from "components/pages/TemplateDetailsPage";
import { getDefaultData as getWorkflowData } from "components/workflows/NonNachaFileImportWorkflow";
import Classes, { Account, ACHFromAccount, ACHTemplate, ACHToParticipant, Company, CompanyAccount, NonNachaParticipants, Participant } from "model";

/**
 * @name CaptureOffsetAccountAdded2
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "ACH - ImportFile (Non-NACHA)" (abi22).
 */
export default function CaptureOffsetAccountAdded2(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = useModel();
    const { options } = branding;
    const hasLOC = options.loc_primary_abi22 === "true";
    const selectedAccount = hasLOC ? Account.initByID(10) :Account.initByID(6);

    let nextParticipantId = Participant.nextID();
    const nonNachaParticipants = NonNachaParticipants.initAll().reduce((acc, item) => {
        const added = Participant.init({
            ...item.record,
            id: nextParticipantId,
        });

        nextParticipantId = parseFloat(nextParticipantId) + 1
        acc.push(added);

        return acc;
    }, []);

    let nextACHToParticipantId = ACHToParticipant.nextID();
    const achToParticipants = nonNachaParticipants.reduce((acc, item) => {
        const added = ACHToParticipant.init({
            id: nextACHToParticipantId,
            participant: Participant.init({ ...item.record, isSelected: "true" }),
            notify: "No",
            addenda: "0",
            numberOfDistributions: "1",
            amount: "1.00"
        });

        nextACHToParticipantId = parseFloat(nextACHToParticipantId) + 1
        acc.push(added);

        return acc;
    }, []);

    const hasSingleAccountUI = options.offset_account_ui_abi22 === "Single Account";
    const achToParticipantsAmount = achToParticipants.reduce((acc, participant) => {
        acc += parseFloat(participant.amount.amount);
        return acc;
    }, 0);

    const selectedTemplate = ACHTemplate.init({
        id: ACHTemplate.nextID(),
        transactionType: "payment",
        secCode: "PPD Credit - Consumer Credit",
        name: "SamplePPD",
        companyDiscretionaryData: "",
        companyEntryDescription: "Payroll",
        creditAmount: "0.00",
        debitAmount: hasSingleAccountUI ? achToParticipantsAmount : "0.00",
        achToParticipants: [],
        achFromAccount: [],
        company: Company.initByID(0),
        companyAccount: CompanyAccount.initByID(0),
        numberOfAccounts: "0"
    });

    const addedAccount = ACHFromAccount.init({ account: "6", id: ACHFromAccount.nextID() });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template" ], selectedTemplate)
    .update([ "achToParticipants", "participants" ], achToParticipants)
    .update([ "achFromAccounts", "accounts" ], [ addedAccount ])
    .update([ "selectedOffsetAccount", "account" ], hasSingleAccountUI ? selectedAccount :  undefined)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getWorkflowData().ui)
    .submit();

    return <TemplateDetailsPage data={ data } ui={ ui } />;
}